import {atom} from 'recoil';
import {Appointment} from "../../models/Appointment";
import {DatePollInfo} from "../../models/DatePollInfo";

export const openBottomDrawerState = atom<boolean>({
    key: 'openBottomDrawerState',
    default: false,
});

export const openAskAttendanceBottomDrawerState = atom<boolean>({
    key: 'openAskAttendanceBottomDrawerState',
    default: false,
});

export const bottomDrawerPollInfoState = atom<DatePollInfo | null>({
    key: 'bottomDrawerPollInfoState',
    default: null,
});